import React from 'react';
import './style.scss';
import clsx from 'clsx';

const HeaderMenuButton = ({ opened, setOpened, setSearchOpened }) => (
  <button
    className="header-menu-button"
    onClick={() => {
      setOpened((prev) => !prev);
      //close the search
      setSearchOpened(false);
      document.getElementById('search-popup-id').classList.remove('show-search-popup');
      document.body.classList.remove('filter-modal-open');
    }}
  >
    <MenuIcon className={clsx('header-menu-icon', opened && 'header-menu-icon-shifted-bottom')} />
    <CloseIcon className={clsx('header-menu-icon', !opened && 'header-menu-icon-shifted-top')} />
  </button>
);

const MenuIcon = ({ className }) => (
  <div className={className}>
    <img src={'/-/media/Project/FAB2/shared/images/icon_burger-white.svg'} />
  </div>
);

const CloseIcon = ({ className }) => (
  <div className={className}>
    <img src={'/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-close-white'} />
  </div>
);

export default HeaderMenuButton;
